import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useSettingsState } from "@/context/SettingsStateContext";
import useWordpressCategories from "@/hooks/useWordpressCategories";

export default function GeneratedCategoryIdeasDialog() {
  const { showCategoryDialog, setShowCategoryDialog, generatedCategories } =
    useSettingsState();
  const { addCategory } = useWordpressCategories();

  return (
    <Dialog open={showCategoryDialog} onOpenChange={setShowCategoryDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Generated Category Ideas</DialogTitle>
          <DialogDescription>
            Here are some category ideas based on your content. Click to add them to your
            WordPress site.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          {generatedCategories.map((category, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 border rounded-lg hover:bg-accent cursor-pointer"
              onClick={() => addCategory(category)}
            >
              <div>
                <h4 className="font-medium">{category.name}</h4>
                <p className="text-sm text-muted-foreground">{category.slug}</p>
              </div>
              <Button variant="ghost" size="sm">
                Add
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
